import React from 'react'

import CopyOption from './copy-option'
import {ModalCopy_CopyOption} from "../../../@types"

type Props = {
    copyOptions         : ModalCopy_CopyOption[]
    selectedOptions     : ID[]

    onCopyOptionSelect  : {(id: ID): void}
}

export default function ProjectForm_CopyOptions(props: Props) {

    return (
        <div className="row">
            <div className="label">Copy</div>
            <div className="element">
                {_.map(props.copyOptions, (option:ModalCopy_CopyOption)=>
                    <CopyOption key         = {option.id}
                                id          = {option.id}
                                title       = {option.title}
                                selected    = {props.selectedOptions.includes(option.id)}
                                onSelect    = {props.onCopyOptionSelect}/>)}
            </div>
        </div>
    )
}
